import { API, graphqlOperation } from "aws-amplify";
import { createUSER_EXTENSION } from "../../graphql/mutations";

export const CreateUSER_EXTENSION = async (postParams) => {
    try {
      const result = await API.graphql(
        graphqlOperation(createUSER_EXTENSION, postParams)
      );
      return result.data.createUSER_EXTENSION;
    } catch (res) {
      const { errors } = res;
      console.error(errors);
    }
  };